__turbopack_context__.v({
  "chips": "account-prioritization-diagram-module__IRJwxG__chips",
  "companyMark": "account-prioritization-diagram-module__IRJwxG__companyMark",
  "connector": "account-prioritization-diagram-module__IRJwxG__connector",
  "desktop": "account-prioritization-diagram-module__IRJwxG__desktop",
  "diagram": "account-prioritization-diagram-module__IRJwxG__diagram",
  "iconDisc": "account-prioritization-diagram-module__IRJwxG__iconDisc",
  "mobile": "account-prioritization-diagram-module__IRJwxG__mobile",
  "mobileArrow": "account-prioritization-diagram-module__IRJwxG__mobileArrow",
  "mobileBadge": "account-prioritization-diagram-module__IRJwxG__mobileBadge",
  "mobileBrief": "account-prioritization-diagram-module__IRJwxG__mobileBrief",
  "mobileOutcomes": "account-prioritization-diagram-module__IRJwxG__mobileOutcomes",
  "mobilePriorities": "account-prioritization-diagram-module__IRJwxG__mobilePriorities",
  "mobileSignals": "account-prioritization-diagram-module__IRJwxG__mobileSignals",
  "mobileStage": "account-prioritization-diagram-module__IRJwxG__mobileStage",
  "mobileStages": "account-prioritization-diagram-module__IRJwxG__mobileStages",
  "mobileTier": "account-prioritization-diagram-module__IRJwxG__mobileTier",
  "mobileTiers": "account-prioritization-diagram-module__IRJwxG__mobileTiers",
  "outcomeGroup": "account-prioritization-diagram-module__IRJwxG__outcomeGroup",
  "panel": "account-prioritization-diagram-module__IRJwxG__panel",
  "stage": "account-prioritization-diagram-module__IRJwxG__stage",
  "stageDetail": "account-prioritization-diagram-module__IRJwxG__stageDetail",
});
